import { api_GET, api_POST, api_PUT, api_DELETE } from "../api/_axios.js";

const formulariovistoria_api =
{
    getAll: function (contrato_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`formulariovistoria/${contrato_Id != null ? contrato_Id : ""}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getListFromWeb: function (contrato_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`formulariovistoria/getListFromWeb/${contrato_Id != null ? contrato_Id : ""}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItemFromWeb: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`formulariovistoria/getItemFromWeb/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`formulariovistoria/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    GetOpcoesQuestao: function (formularioVistoriaQuestao_id, boletimVistoriaInspecaoId) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`formulariovistoria/GetOpcoesQuestao/${formularioVistoriaQuestao_id}/${boletimVistoriaInspecaoId}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postFormularioVistoria: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`formulariovistoria/PostFormularioVistoria`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putFormularioVistoria: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`formulariovistoria/PutFormularioVistoria`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postFormularioVistoriaCabecalho: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`formulariovistoria/PostFormularioVistoriaCabecalho`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putFormularioVistoriaCabecalho: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`formulariovistoria/PutFormularioVistoriaCabecalho`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    deleteFormularioVistoriaCabecalho: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`formulariovistoria/DeleteFormularioVistoriaCabecalho`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    postFormularioVistoriaQuestao: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`formulariovistoria/PostFormularioVistoriaQuestao`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    putFormularioVistoriaQuestao: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`formulariovistoria/PutFormularioVistoriaQuestao`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    deleteFormularioVistoriaQuestao: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`formulariovistoria/DeleteFormularioVistoriaQuestao`, id).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default formulariovistoria_api
